import {BlueRibbonJackpot} from './blue_ribbon_jackpot';

export class BlueRibbonPersonalJackpot extends BlueRibbonJackpot {
}